import {useState, useEffect} from 'react';
import MailchimpSubscribe from "react-mailchimp-subscribe";

const postUrl = import.meta.env.PUBLIC_MAILCHIMP_NEWSLETTER_FORM

const CustomForm = ({ status, message, onValidated }: any) => {
  const [email, setEmail] = useState<string>('');
  const emailRegex = "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$"

  const handleSubmit = (e: any) => {
    e.preventDefault();
    email &&
    email.indexOf("@") > -1 &&
    onValidated({
      EMAIL: email
    });
  }

  useEffect(() => {
    if(status === "success") setEmail('');
  }, [status])

  return (
    <form onSubmit={(e) => handleSubmit(e)}>
      <input
        className="text-small text-black placeholder:text-gray w-full"
        type="email"
        placeholder="Email address…"
        value={email}
        onChange={(event) => setEmail(event.target.value)}
      />
      <div className='h-[1px] bg-gray w-full mt-2 mb-10 w-full' />
      <div className="mt-20">
        <button
          className="w-fit text-main border-main border px-10 py-2 hover:bg-main hover:text-white disabled:cursor-not-allowed disabled:text-gray disabled:border-gray disabled:hover:bg-white"
          type="submit"
          disabled={email && email.match(emailRegex) ? false : true}
        >
          Subscribe
        </button>
      </div>
      {status === "sending" && (
        <div className="mt-20 text-main">
          Sending...
        </div>
      )}
      {status === "error" && (
        <div 
          className="mt-20 text-main"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
      {status === "success" && (
        <div
          className="mt-20 text-shopPay"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      )}
    </form>
  );
};

export default function NewsletterForm() {
  return (
    <div className="mt-20">
      <MailchimpSubscribe
        url={postUrl}
        render={({ subscribe, status, message }) => (
          <CustomForm
            status={status} 
            message={message}
            onValidated={(formData: any) => subscribe(formData)}
          />
        )}
      />
    </div>
  );
}